<div class="live-incident-banner pointer" (click)="bannerClick.emit()">
    <div class="large-wrapper live-incident-banner__wrapper">
        <div class="live-incident-banner__inner-wrapper">
            <div class="live-incident-banner__icon">
                <img alt="MySupportSpace Discover" src="assets/icons/notifications.png" />
            </div>

            <div class="live-incident-banner__content">
                <div class="live-incident-banner__title">
                    {{ banner.title }}
                </div>

                <div class="live-incident-banner__description">
                    {{ banner.description }}
                </div>
            </div>
        </div>
    </div>
</div>
